import React, { useRef, useState, useEffect } from "react";
import "./DatePickerNew.css";
import { SlCalender } from "react-icons/sl";
import { formatForInput } from "../../../../../Utils/datepickerFormat";

interface datePickerProps {
  disabled: boolean;
  inputType: string;
  name?: string;
  errorMessage?: string | undefined | string[];
  iserror?: boolean;
  value?: string | number;
  label?: string;
  inputRegex?: string;
  maxDate?: string;
  minDate?: string; // add this
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
}

export const DatePickerNew = ({
  disabled,
  label,
  iserror,
  name,
  value,
  maxDate,
  minDate, // add this
  onChange,
  onBlur,
  errorMessage,
}: datePickerProps) => {
  //   alert(value);

  const hiddenDateRef = useRef<HTMLInputElement | null>(null);
  const [textValue, setTextValue] = useState<string>(formatForInput(value));

  useEffect(() => {
    setTextValue(formatForInput(value));
  }, [value]);

  const openCalendar = () => {
    if (hiddenDateRef.current) {
      hiddenDateRef.current.showPicker?.(); // modern browsers
      hiddenDateRef.current.click();
    }
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedDate = e.target.value;

    // Empty means the native picker's clear ("x") button was used —
    // propagate that instead of silently ignoring it, same as
    // tryParseAndSave does for the text input.
    onChange &&
      onChange({
        target: { name, value: selectedDate },
      });
  };


  const autoFormatDate = (rawInput: string, prevValue: string): string => {

    let digits = rawInput.replace(/\D/g, "");


    const isDeleting = rawInput.length < prevValue.length;

    if (isDeleting) {

      return rawInput.replace(/[^\d/]/g, "");
    }


    digits = digits.slice(0, 8);

    let formatted = "";
    if (digits.length <= 2) {
      formatted = digits;
    } else if (digits.length <= 4) {
      formatted = `${digits.slice(0, 2)}/${digits.slice(2)}`;
    } else {
      formatted = `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
    }

    return formatted;
  };


  const tryParseAndSave = (text: string) => {
    if (!text) {
      // Field was cleared intentionally — propagate that up instead of
      // silently keeping the old formik value while the input looks empty.
      onChange &&
        onChange({
          target: { name, value: "" },
        });
      return;
    }

    const match = text.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) {
      setTextValue(formatForInput(value));
      return;
    }

    const [, dd, mm, yyyy] = match;
    const isoDate = `${yyyy}-${mm}-${dd}`;
    const dateObj = new Date(isoDate);

    const dayNum = parseInt(dd, 10);
    const monthNum = parseInt(mm, 10);
    const isValidCalendarDate =
      !isNaN(dateObj.getTime()) &&
      monthNum >= 1 &&
      monthNum <= 12 &&
      dayNum >= 1 &&
      dayNum <= 31;

    if (!isValidCalendarDate) {
      setTextValue(formatForInput(value));
      return;
    }

    onChange &&
      onChange({
        target: { name, value: isoDate },
      });
  };

  return (
    <div className="date-picker-wrapper">
      <div className="input-wrapper-label">
        <label className="input-label">
          <p>{label}</p>
        </label>
      </div>
      <div className="date-picker-control">
        <input
          type="text"
          className="date-input"
          placeholder="dd/mm/yyyy"
          maxLength={10}
          value={textValue}
          onChange={(e) => {
            const formatted = autoFormatDate(e.target.value, textValue);
            setTextValue(formatted);

            if (formatted.length === 10) {
              tryParseAndSave(formatted);
            }
          }}
          onBlur={(e) => {
            tryParseAndSave(e.target.value);
            onBlur && onBlur(e);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              tryParseAndSave((e.target as HTMLInputElement).value);
            }
          }}
        />

        <button type="button" className="calendar-btn" onClick={openCalendar}>
          <SlCalender />
        </button>

        <input
          ref={hiddenDateRef}
          type="date"
          value={value}
          className="hidden-date-input"
          onChange={handleDateChange}
        />
      </div>
    </div>
  );
};


